<template>
  <div class="container">
    <div class="row">
        <div class="col-12 col-lg-8 g c">
            <div class="card card-body">
                <h5>
                    {{ ticket.title }}
                </h5>
                <div class="chat-container g" id="mydiv">
                    <div v-for="message in messages" :key="message._id" :class="'message text-white ' + (message.from == 0 ? 'bg-primary' : 'bg-success left')">
                        <strong>{{ message.message }}</strong>
                        <template v-if="message.file && message.file != ''">
                            <div style="width: auto !important">
                                <a :href="message.file" target="_blank" class="text-white">
                                    <i class="fa fa-file"></i>
                                    عرض المرفق
                                </a>
                            </div>
                        </template>
                        <br v-if="!message.file || message.file == ''">
                        <small class="text-muted">{{ message.date }} - {{ message.seen ? 'تمت رؤيتها' : 'تم الارسال' }}</small>
                    </div>
                </div>
                <input type="file"
                    class="form-control dnone" id="ingredient_file" @change="uploadImage()" accept=".jpg,.png,.gif,.jpeg,.doc,.docx,.pdf,.xls,.xlsx">
                <div class="input-group mb-3"  v-if="ticket.status == 0">
                    <input type="text" class="form-control" placeholder="الرسالة هنا..." v-on:keyup.enter="send" style="border-radius: 0px" v-model="message">
                    <button class="input-group-text" @click="listenupload()" id="basic-addon1" style="border-radius: 0px"><i class="fa fa-paperclip"></i>{{ mobile() ? '' : ' مرفق' }}</button>
                    <button :class="'input-group-text btn ' + (message != '' || file != '' ? 'btn-primary' : '')" style="border-radius: 0px" @click="send()">{{ mobile() && file == '' ? '' : 'ارسال ' }}<i class="fa fa-paper-plane"></i></button>
                </div>
                <span class="text-center" v-if="ticket.type == 'ticket' && ticket.status == 0">
                    هل تم حل مشكلتك؟ <a href="javascript:;" @click="end()">
                        انهاء التذكرة الآن
                    </a>
                </span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            ticket: {},
            messages: [],
            message: "",
            file: "",
            user: JSON.parse(localStorage.getItem("user")),
        }
    },
    created(){
        this.gett()
    },
    methods: {
        end(){
            var g = this;
            if(confirm("متأكد من اغلاق التذكرة؟")){
                $.post(api + '/user/general/ticket/end', {
                    jwt: this.user.jwt,
                    id: window.location.href.split("/ticket/")[1],
                }).then(function(r){
                    g.gett()
                }).fail(function(){
                    g.error = "حدث مشكلة في الاتصال"
                })
            }
        },
        listenupload(){
            var g = this;
            $("#ingredient_file").click()
        },
        uploadImage(){
            var g = this;
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();
                g.uploading = true;
                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                formData.append("jwt", g.user.jwt);

                $.ajax({
                type: "POST",
                url: api + '/user/general/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    g.uploading = false;
                    if(data.status != 100){
                        alert("هذا الملف غير مدعوم", 200)
                        return;
                    }
                    g.file = data.response
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                    g.uploading = false;
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#ingredient_file")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        },
        mobile(){
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        },
        gett(){
            var g = this;
            $.post(api + '/user/general/ticket', {
                jwt: this.user.jwt,
                id: window.location.href.split("/ticket/")[1]
            }).then(function(r){
                g.ticket = r.response.ticket;
                g.messages = r.response.messages;
                setTimeout(function(){
                    $("#mydiv").scrollTop($("#mydiv")[0].scrollHeight);
                }, 100)
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        },
        send(){
            var g = this;
            $.post(api + '/user/general/ticket/send', {
                jwt: this.user.jwt,
                id: window.location.href.split("/ticket/")[1],
                message: g.message,
                file: g.file
            }).then(function(r){
                g.message = "";
                g.file = "";
                g.gett()
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        },
    }
}
</script>

<style>
.chat-container{
    height: 400px;
    border: 2px solid #eee;
    overflow-y: scroll;
    background: #fafafa;
}
.message{
    width: 90%;
    padding: 10px;
    border-radius: 10px 10px 10px 0px;
    margin-top: 10px;
    float: left;
}
.left{
    float: right;
    border-radius: 10px 10px 0px 10px;
}
.message:nth-child(1){
    margin-top: 0px;
}
</style>